/* Small shared axios client for /api/health that automatically appends the
   X-Health-Token session header. Falls back gracefully when the session is
   missing so the guard can catch it and prompt the user to unlock. */
import api from "@/lib/api";

const KEY = "nl_health_token";

export const getHealthToken = () => localStorage.getItem(KEY) || "";
export const setHealthToken = (t) => localStorage.setItem(KEY, t);
export const clearHealthToken = () => localStorage.removeItem(KEY);

const withHeader = (config = {}) => {
  const tok = getHealthToken();
  const headers = { ...(config.headers || {}) };
  if (tok) headers["X-Health-Token"] = tok;
  return { ...config, headers };
};

const health = {
  get: (url, cfg) => api.get(`/health${url}`, withHeader(cfg)),
  post: (url, data, cfg) => api.post(`/health${url}`, data, withHeader(cfg)),
  put: (url, data, cfg) => api.put(`/health${url}`, data, withHeader(cfg)),
  delete: (url, cfg) => api.delete(`/health${url}`, withHeader(cfg)),
};

export default health;
